import { SessionContext } from '@/context/session';
import { useContext } from 'react';

export const useSession = () => {
    const sessionValues = useContext(SessionContext);

    return sessionValues
}
